/*
 * Copyright (c) 2026 CalAmp Corp.  All Rights Reserved
 */
import React from 'react';
import {IconProps} from '../../types/types';
import useIconDLS from '../useIconDLS';

/*
 * Defines the Design Language System (DLS) System Bookmark Icon component.
 */
export const SystemBookmarkIcon = (props: IconProps) => {
  const {iconSize, iconColor} = useIconDLS(props);
  return (
    <svg width={iconSize} height={iconSize} viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path d='M6 6.5C6 6.22386 6.22386 6 6.5 6H16.5C16.7761 6 17 6.22386 17 6.5V19.1243C17 19.5113 16.5792 19.7516 16.2458 19.5549L11.5783 16.7998C11.4169 16.7045 11.2158 16.7075 11.0573 16.8076L6.7669 19.5159C6.43396 19.7261 6 19.4868 6 19.0931V6.5Z' stroke={iconColor} strokeWidth='1.5' strokeMiterlimit='10' />
    </svg>
  );
};

export default SystemBookmarkIcon;
